import React from "react";

/**
 * Textarea with design-system field pattern.
 * @param {Object} props
 * @param {string} [props.label]
 */
export function Textarea({ label, id, className = "", ...rest }) {
  return (
    <div className="ds-field">
      {label && <label className="ds-field-label" htmlFor={id}>{label}</label>}
      <textarea id={id} className={`ds-textarea ${className}`.trim()} {...rest} />
    </div>
  );
}
